import styled, { css } from 'styled-components'

type StepIndicatorProps = {
  valid: boolean
}

export const StepIndicator = styled.div<StepIndicatorProps>`
  position: relative;
  width: 32px;
  height: 32px;
  border: 1px solid var(--neutralLowLightest);
  border-radius: 32px;
  text-align: center;
  line-height: 32px;
  background-color: var(--neutralHighLight);
  ${({ valid }) => {
    if (valid) {
      return css`
        &::after {
          content: '';
        }
      `
    }
    return null
  }}
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 1rem;
`

export const LinkButton = styled.button`
  color: var(--primary);
  padding: 1em 1em 1em 0;
`

export const ValidCheck = styled.div`
  color: #fff;
  background: rgb(75, 191, 115);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  position: absolute;
  right: -0.7em;
  bottom: -0.7em;
  border: 2px solid #fff;
  font-size: 10px;
  box-sizing: content-box;
  align-content: center;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const StepIndicatorWrapper = styled.div`
  ${({ theme }) => css`
    text-transform: uppercase;
    background-color: ${theme.colors.neutral.high.light};
    padding: ${theme.spacings.tiny};
    border-radius: ${theme.border.radius.small};
    font-size: ${theme.font.sizes.xxsmall};
    font-weight: ${theme.font.bold};
  `}
`
